import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// A logo agora é referenciada pelo caminho público
const LogoImage = '/logoscaliz.png'; 

const Logo: React.FC = () => {
  return (
    <Link to="/">
      <motion.div 
        className="flex items-center gap-3 cursor-pointer"
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 400, damping: 10 }}
        whileTap={{ scale: 0.95 }}
      >
        <motion.img 
          src={LogoImage}
          alt="Scaliz Logo"
          className="size-8"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        />
        <motion.h2 
          className="text-[#181411] dark:text-white text-lg font-black leading-tight tracking-[-0.015em]"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Scaliz
        </motion.h2>
      </motion.div>
    </Link>
  );
};

export default Logo;